import { mapActions } from 'vuex'

export default {
    methods: {
        ...mapActions('cart', [
            'update'
        ]),

        incrementQuantity() {
            this.$loading.show()
            this.update({ id: this.item.id, quantity: this.item.quantity + 1 })
        },

        decrementQuantity() {
            this.$loading.show()
            this.update({ id: this.item.id, quantity: this.item.quantity - 1 })
        }
    }
}
